export default "__VITE_ASSET__8ca5d655__"